import { useState } from "react";
import OTPInput from "react-otp-input";
import { useSelector } from "react-redux";
import { Bounce, toast } from "react-toastify";
import { RootState } from "services/redux/store";
import { Button, CountDown } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type SignupForm2Props = CustomComponentProps & {
    email: string;
    otp: string;
    changeOtp: React.Dispatch<React.SetStateAction<string>>;
    validOtp?: boolean;
    changeStep: React.Dispatch<React.SetStateAction<number>>;
    step: number;
};

const SignupForm2 = ({
    email,
    otp,
    changeOtp,
    // validOtp = false,
    changeStep,
    step
}: SignupForm2Props) => {
    const mode = useSelector((state: RootState) => state.site.mode);

    const [resend, setResend] = useState(false);
    const [timer, setTimer] = useState(false);

    const handleResendOtp = async () => {
        setTimer(true);
        toast.success("OTP sent to your email", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: mode == "light" ? "light" : "dark",
            transition: Bounce
        });
    };

    const handleVerify = async () => {
        !resend && setResend(true);
        toast.success("OTP sent to your email", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: mode == "light" ? "light" : "dark",
            transition: Bounce
        });
    };

    return (
        <div
            id="signup-panel-2"
            className={`process-panel-wrap is-narrow ${step == 1 ? "is-active" : ""}`}
        >
            <div className="form-panel">
                <h3 className="text-center mb-20">
                    A code has been sent to{" "}
                    <span className="fw-700"> {email}</span>
                </h3>
                <div className="digit-group mb-20">
                    <OTPInput
                        onChange={(val) => changeOtp(val)}
                        value={otp}
                        inputStyle="inputStyle"
                        numInputs={6}
                        renderSeparator={" "}
                        renderInput={(props) => <input {...props} />}
                    />
                </div>

                <div className="d-flex flex-col gap-20 flex-a-center">
                    {resend ? (
                        <p className="text-center d-flex flex-a-center gap-5">
                            {timer ? (
                                <CountDown seconds={120} handleEnd={setTimer} />
                            ) : (
                                <Button
                                    text="Resend"
                                    rounded={true}
                                    color=""
                                    type="is-phantom"
                                    handleClick={handleResendOtp}
                                />
                            )}
                        </p>
                    ) : (
                        ""
                    )}
                    <Button
                        text="Verify"
                        rounded={true}
                        handleClick={() => handleVerify()}
                    />
                </div>
            </div>

            <div className="buttons">
                <Button
                    text="Back"
                    handleClick={() => changeStep(step - 1)}
                    color=""
                />
                <Button text="Next" handleClick={() => changeStep(step + 1)} />
            </div>
        </div>
    );
};

export default SignupForm2;
